import { graphql, useStaticQuery } from "gatsby"
// import Img from "gatsby-image"
import { navigate } from "gatsby"
import React, { useContext, useState } from "react"
// import { SliderLightbox as Lightbox } from "../../design-system/organisms/lightbox"
import Grid from "../shared/grid"
// import useIndustryGalleryImages from "../shared/hooks/useIndustryGalleryImages"
// import useLightboxManager from "../shared/hooks/useLightboxManager"
import { UIContext } from "../shared/layout"
import ImageTiles from "../shared/solutions.imagetile"
import {
  CompanyBlockStyle,
  Container,
  ContentBlock,
  ContentBlockText,
  ContentBlockTitle,
  ImageTileContainer,
  MapImage,
  PropertiesBlockStyle,
  Spacer,
} from "./overview.style"

export default function Overview() {
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  const query = useStaticQuery(graphql`
    query {
      mapLg: file(
        relativePath: { eq: "4_COMPANY/About/company_map_desk.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mapMd: file(
        relativePath: { eq: "4_COMPANY/About/company_map_tablet.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mapSm: file(
        relativePath: { eq: "4_COMPANY/About/company_map_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const imageSizes = {
    sm: query.mapSm,
    md: query.mapMd,
    lg: query.mapLg,
  }

  // const fluidImages = useIndustryGalleryImages()
  // const [isLightboxVisible, _toggleLightbox] = useLightboxManager()
  const [selectedLightbox, setSelectedLightbox] = useState("")
  const toggleLightbox = (id) => {
    setSelectedLightbox(id)
    // _toggleLightbox()
  }
  return (
    <>
      <Container>
        <Grid>
          <ContentBlock styleModifier={CompanyBlockStyle}>
            <ContentBlockTitle>Our Company</ContentBlockTitle>
            <ContentBlockText>
              Headquartered in Waterloo, Ontario, Mappedin is the leading
              platform for indoor spatial data management, digitizing venues,
              and building best-in-class indoor mapping experiences.
              <br />
              <br /> Built for scale, our flexible platform and enterprise grade
              tools enable us to work with leading operators and developers
              around the world.
            </ContentBlockText>
          </ContentBlock>
          <MapImage fluidSizes={imageSizes} imgStyle={{ objectFit: "cover" }} />
          <Spacer />
          <ContentBlock styleModifier={PropertiesBlockStyle}>
            <ContentBlockTitle>
              Mapping a Diverse Set of Properties
            </ContentBlockTitle>
            <ContentBlockText>
              At Mappedin, we’ve set out to digitize all indoor spaces,
              regardless of vertical. We enable our customers to leverage those
              maps for a variety of use cases and experiences.
            </ContentBlockText>
          </ContentBlock>
          <ImageTileContainer>
            <ImageTiles
              onClick={toggleLightbox}
              carousel={breakpoint === "sm"}
            />
          </ImageTileContainer>
        </Grid>
      </Container>
      {/* 
          The lightboxes have been disabled temporarily and replaced with links to their respective industry pages.
          I've left the code to be plugged back in when new lightbox images are provided. 
      */}
      {
        // isLightboxVisible &&
        selectedLightbox === "malls" && navigate("/industries/malls/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["mall"] &&
        //     fluidImages["mall"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
      {
        // isLightboxVisible &&
        selectedLightbox === "offices" && navigate("/industries/offices/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["office"] &&
        //     fluidImages["office"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
      {
        // isLightboxVisible &&
        selectedLightbox === "stadiums" && navigate("/industries/stadiums/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["stadium"] &&
        //     fluidImages["stadium"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
      {
        // isLightboxVisible &&
        selectedLightbox === "retail" && navigate("/industries/retail/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["retail"] &&
        //     fluidImages["retail"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
    </>
  )
}
